
import { apiClient } from "~/lib/utils/axios";

export const getOnboardingVideos = () => {
  return apiClient
    .get(`/onboarding/playlists`)
    .then((response) => response.data);
};
